/**
 * Logout button component
 */
import React from 'react';
import { authService } from '../../utils/auth';

interface LogoutButtonProps {
  className?: string;
  showIcon?: boolean;
}

export const LogoutButton: React.FC<LogoutButtonProps> = ({ 
  className = '', 
  showIcon = true 
}) => {
  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      authService.logout();
    }
  };

  return (
    <button
      onClick={handleLogout}
      className={`inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors ${className}`}
      title="Logout"
    >
      {showIcon && (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
      )}
      Logout
    </button>
  );
};